import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Alerts from './components/Alerts';

const alerts = (props,{ t }) => (
  <Container>
    <Alerts {...props} />
  </Container>
);

alerts.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(alerts);
